import { CustomList, Icon, List } from "components";
import { JOB_TYPES } from "@/lib/constants";
import { TIMESHEET_MYPROJECTS_REVIEW } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "ui/components/tooltip";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { useTimesheetJobAggregates } from "../components/useTimesheetJobAggregates";
import { StatusCell } from "@/components/status/cell";
import { EmployeeCell } from "components/cell/employee/cell";
import { DateCell } from "@/components/date/cell";
import { HoursCell } from "@/components/hours/cell";

export default function JobsTimesheetFromProject() {
  const [timesheetData, setTimesheetData] = useState([]);
  const { projectSlug } = useParams();

  const { aggregateDataMap, loadingStateMap } =
    useTimesheetJobAggregates(timesheetData);

  const columns = [
    {
      id: "name",
      header: "Job",
      accessorKey: "name",
      sortable: true,
    },
    {
      id: "type",
      header: "Type",
      accessorKey: "type",
      cell: ({ getValue }) => {
        return (
          <Tooltip>
            <TooltipTrigger>
              <Icon
                icon={JOB_TYPES[getValue()].icon}
                className="text-muted-foreground size-4"
              />
            </TooltipTrigger>
            <TooltipContent>{JOB_TYPES[getValue()].label}</TooltipContent>
          </Tooltip>
        );
      },
      sortable: false,
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
    {
      id: "coordinator",
      header: "JC",
      accessorKey: "coordinator",
      cell: EmployeeCell,
    },
    {
      id: "logged_hours",
      accessorKey: "logged",
      header: "Logged",

      cell: HoursCell,
    },
    {
      id: "approved_hours",
      header: "Approved",
      accessorKey: "approved",
      cell: HoursCell,
    },

    {
      id: "unreviewed_hours",
      header: "Unreviewed",
      accessorKey: "unreviewed",
      cell: HoursCell,
    },
    {
      id: "end_date",
      header: "End Date",
      accessorKey: "end_date",
      sortable: true,
      cell: DateCell,
    },
  ];

  const defaultFilters = {
    projectId: projectSlug,
  };

  return (
    <CustomList
      storageKey={projectSlug}
      title=""
      endPoint="custom-ui/get-pc-timesheet-summary-per-job"
      filters={defaultFilters}
      showSearch={false}
      perPage={25}
      columns={columns}
      teleportFilters={true}
      href={(item) => `/${TIMESHEET_MYPROJECTS_REVIEW}/${item.id}`}
    />
  );
}
